import styled from 'styled-components';

export const StyledAccordionSectionContent = styled.div`
   padding-bottom: 20px;
`;
StyledAccordionSectionContent.displayName = 'StyledAccordionSectionContent';
